import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { ProteccionConsumidorService } from '../services/proteccion-consumidor.service';
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';
import { Router } from '@angular/router';
import { InfoPantallaDTO } from '../../../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../../../services/util.service';
import { Constants } from '../../../../../constants/constants';
import { TramiteService } from '../../../../../services/tramite.service';
import { AnexoPrecargaResponseDto } from '../../../../../dto/anexo/anexo-tramite.dto';
import { Location } from '@angular/common';
import { firstValueFrom, from } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { PersonaDto } from '../../../../../dto/tramites/persona.dto';
import { DatosDemandanteComponent } from '../datos-demandante/datos-demandante.component';
import { DatosDemandadoComponent } from '../datos-demandado/datos-demandado.component';
import { ReclamoDirectoComponent } from '../reclamo-directo/reclamo-directo.component';
import { ProteccionQueRequiereComponent } from '../proteccion-que-requiere/proteccion-que-requiere.component';
import { PretensionesComponent } from '../pretensiones/pretensiones.component';
import { PruebasComponent } from '../pruebas/pruebas.component';
import { ArchivosFormDTO } from '../../../../../dto/expediente/archivos-form.dto';
import { ListaValorRequestDto, ListaValorResponseDto } from '../../../../../dto/tramites/lista_valor.dto';
import { ListaValorService } from '../services/lista-valor.service';
import { LanguageService } from '../../../../../services/util/language.service';
import { TipoPretensionDto } from '../../../../../dto/tramites/sic/tipo-pretension.dto';

interface EstadoPasos {
  paso: string;
  valor?: boolean;
}

@Component({
  selector: 'app-proteccion-consumidor',
  templateUrl: './proteccion-consumidor.component.html',
  styleUrl: './proteccion-consumidor.component.scss',
})
export class ProteccionConsumidorComponent implements OnInit, OnDestroy {
  idiomaActual: string = 'es';
  @ViewChild(DatosDemandanteComponent)
  componenteDemandante!: DatosDemandanteComponent;
  @ViewChild(DatosDemandadoComponent)
  componenteDemandado!: DatosDemandadoComponent;
  @ViewChild(ReclamoDirectoComponent)
  componenteReclamoDirecto!: ReclamoDirectoComponent;
  @ViewChild(ProteccionQueRequiereComponent)
  componenteProteccion!: ProteccionQueRequiereComponent;
  @ViewChild(PretensionesComponent)
  componentePretension!: PretensionesComponent;
  @ViewChild(PruebasComponent)
  componentePruebas!: PruebasComponent;

  tipoPersona?: number;
  idTramite = 0;
  tramiteSIC?: TramiteSicProteccionConsumidorDto;
  ultimoPaso = false;
  paso = 0;
  estadoPasos: EstadoPasos[] = [];

  //Componente carga archivos
  archivosPreCargados?: AnexoPrecargaResponseDto[];
  mostrarComponenteCarga: boolean = true;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  isVolver: boolean = false;
  formTipoDemandante!: FormGroup;
  formDemandante!: FormGroup;
  formApoderado!: FormGroup;
  formTipoDemandado!: FormGroup;
  formDemandado!: FormGroup;
  formReclamo!: FormGroup;
  nombreCortoLimpio = '';
  nombreCompleto = '';
  proceso: string = '';
  entidad: string = '';
  // apoderado: PersonaDto = {};

  listaTipoReclamacion: ListaValorResponseDto[] = [];

  festivos: string[] = [];
  pretenciones: TipoPretensionDto[] = [];
  constructor(
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
    private readonly alertaModalService: AlertaModalService,
    private readonly tramiteService: TramiteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly listaValorService: ListaValorService,
    private languageService: LanguageService,
  ) {
    this.getDiasFestivos();
  }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    const nombreCorto = sessionStorage.getItem('tramiteSeleccionado');
    const nombreCompleto = sessionStorage.getItem('nombreTramite');
    if (nombreCorto && nombreCompleto) {
      this.nombreCortoLimpio = nombreCorto.trim().replace(/^"|"$/g, '').toUpperCase();
      this.nombreCompleto = nombreCompleto.trim().replace(/^"|"$/g, '');
    }
    this.tramiteService.obtenerNombreEntidadPorIdNombreCorto(2, this.nombreCortoLimpio).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de protección al consumidor en la entidad ' +
        'Superintendencia de Industria y Comercio',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de protección al consumidor ' +
        'en la Superintendencia de Industria y Comercio',
      pasos: [],
      change: async op =>
        await this.volver(this.alertaModalService, this.location, op),
    };

    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        Constants.SIC_PROCON
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.consultarTramitePorID(resp.Id);
              this.mostrarComponenteCarga = false;
            },
            () => {
              this.tramiteSIC = undefined;
            },
            true
          );
        } else {
          this.tramiteSIC = undefined;
        }
      });

    this.utilService.changeInfoPantalla(this.infoPantalla);
    sessionStorage.removeItem('demandantes');
    sessionStorage.removeItem('demandados');
    sessionStorage.removeItem('apoderado');
    sessionStorage.removeItem(Constants.ARCHIVOS_SIC_PROCON_PASO_SIETE);
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
    this.listaValor();
    sessionStorage.removeItem(Constants.ARCHIVOS_SIC_PROCON_PASO_UNO);
  }

  // lista
  getDiasFestivos() {
    this.listaValorService.getFestivos().subscribe((response: { Id: number; Fecha: string }[]) => {
      this.festivos = response.map(f => new Date(f.Fecha).toISOString().split('T')[0]);
      sessionStorage.setItem(
        Constants.LISTA_FESTIVOS,
        JSON.stringify(this.festivos)
      );

    });
  }

  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.proteccionConsumidorService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
        this.archivosPreCargados = resp.anexos;
        this.mostrarComponenteCarga = true;
        this.tramiteSIC = resp;
      });
  }

  async volver(alertas: AlertaModalService, loc: Location, op?: () => void) {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    if (this.tramiteSIC == undefined) {
      this.tramiteSIC = {
        id: null,
        idTipoTramite: 2,
        anexos: [],
        demandado: [],
        demandante: [],
        notificacionesDemandado: null,
        notificacionesDemandante: null,
        tipoTramite: 'SIC_PROCON',
        tieneAccesoMediosTecnologicos: null,
        usuario: {
          id: infoInicioSesion.idUsuario,
        },
        enviar: false,
      };
    }
    if (this.formDemandante && this.formDemandante.valid) {
      this.agregarDemandante();
    } else {
      let demandantes: PersonaDto[] = JSON.parse(
        sessionStorage.getItem('demandantes')!
      );
      if (
        this.tramiteSIC.demandante == undefined ||
        this.tramiteSIC.demandante.length == 0
      ) {
        if (demandantes) {
          demandantes.forEach(elemento => {
            const existe = this.tramiteSIC?.demandante?.some(d =>
              d.idTipoIdentificacion === elemento.idTipoIdentificacion &&
              d.identificacion === elemento.identificacion
            );

            if (!existe) {
              this.tramiteSIC?.demandante?.push(elemento);
            }
          });
        }
      } else {
        if (demandantes) {
          demandantes.forEach(elemento => {
            const existe = this.tramiteSIC?.demandante?.some(d =>
              d.idTipoIdentificacion === elemento.idTipoIdentificacion &&
              d.identificacion === elemento.identificacion
            );

            if (!existe) {
              this.tramiteSIC?.demandante?.push(elemento);
            }
          });
        }
      }

    }
    if (this.formApoderado?.valid) {
      this.agregarApoderado();
    }
    if (this.formDemandado != undefined) {
      let demandados: PersonaDto[] = JSON.parse(
        sessionStorage.getItem('demandados')!
      );
      if (this.formDemandado.valid) {
        this.agregarDemandado();
      } else {
        if (
          this.tramiteSIC.demandado == undefined ||
          this.tramiteSIC.demandado.length == 0
        ) {
          if (demandados) {
            demandados.forEach(elemento => {
              this.tramiteSIC?.demandado?.push(elemento);
            });
          }
        }
      }
    } else {
      let demandados: PersonaDto[] = JSON.parse(
        sessionStorage.getItem('demandados')!
      );
      if (
        this.tramiteSIC.demandado == undefined ||
        this.tramiteSIC.demandado.length == 0
      ) {
        if (demandados) {
          demandados.forEach(elemento => {
            this.tramiteSIC?.demandado?.push(elemento);
          });
        }
      } else {
        if (demandados) {
          demandados.forEach(elemento => {
            if (elemento.id == undefined) {
              this.tramiteSIC?.demandado?.push(elemento);
            }
          });
        }
      }
    }
    if (this.formReclamo != undefined) {
      this.agregarReclamo();
    }
    if (!this.tramiteSIC.tipoPretension) {
      if (this.pretenciones.length > 0) {
        this.tramiteSIC.tipoPretension = this.pretenciones;
      }
    }
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          if (this.tramiteSIC) {
            this.tramiteSIC.enviar = false;
            const response = await this.enviar(this.tramiteSIC, false);
            if (response.success) {
              if (op) {
                op();
              } else {
                loc.back();
              }
            } else {
              await alertas.confirmacion(
                this.alertaText['salir-o-continuar-diligenciando'],
                this.alertaText['datos-no-guardados'],
                () => {
                  if (op) {
                    op();
                  } else {
                    loc.back();
                  }
                },
                () => {
                  // El usuario decide continuar diligenciando
                }
              );
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  siguiente(
    data: {
      tramite: TramiteSicProteccionConsumidorDto;
      formValid: boolean;
      event: Event;
      archivo?: ArchivosFormDTO | null | undefined;
    },
    paso: number
  ) {
    if (data.tramite.demandante) {
      sessionStorage.setItem(
        'demandantes',
        JSON.stringify(data.tramite.demandante)
      );
    }
    if (data.tramite.demandado) {
      sessionStorage.setItem(
        'demandados',
        JSON.stringify(data.tramite.demandado)
      );
    }

    const indice = this.estadoPasos.findIndex(
      estado => estado.paso === `Paso ${paso}`
    );

    if (indice !== -1) {
      // Si el paso existe, reemplazar su valor
      this.estadoPasos[indice].valor = data.formValid;
    } else {
      // Si el paso no existe, agregarlo a la lista
      if (paso == 1) {
        this.estadoPasos.push({
          paso: `Paso ${paso}`,
          valor: data.tramite?.demandante?.length! > 0,
        });
      } else {
        this.estadoPasos.push({ paso: `Paso ${paso}`, valor: data.formValid });
      }
    }

    const tramite = data.tramite;

    if (this.tramiteSIC && this.tramiteSIC.id) {
      this.idTramite = this.tramiteSIC.id;
      tramite.id = this.tramiteSIC?.id;
    }
    tramite['tipoTramiteNombreCorto'] = this.nombreCortoLimpio;
    tramite.idioma = this.idiomaActual;

    this.ultimoPaso = paso === 8;
    this.paso = paso + 1;
    this.proteccionConsumidorService
      .crear(tramite, false, data.archivo)
      .subscribe((dataTramite: TramiteSicProteccionConsumidorDto) => {
        this.tramiteSIC = dataTramite;
      });

    this.continuarLineaAvance(data.event);
  }

  subirArchivos(
    data: { subio: boolean; event: Event },
    paso: number,
    guardarSinEnviar: boolean
  ) {
    this.ultimoPaso = paso === 8;
    if (!guardarSinEnviar) {
      if (data.subio) {
        this.paso = paso + 1;
        this.continuarLineaAvance(data.event);
      }
    } else {
      this.alertaModalService.exito(
        this.alertaText['solicitud-pendiente-finalizar'],
        this.alertaText['sic-procon-alertas']['tramite-enviado-mensaje'].replace('{{proceso}}', this.proceso)
          .replace('{{entidad}}', this.entidad)
      );
    }
  }

  anterior(paso: number) {
    const encontrarPaso = this.estadoPasos.find(
      item => item.paso === `Paso ${this.paso}`
    );

    if (encontrarPaso) {
      switch (this.paso) {
        case 1: {
          encontrarPaso.valor = this.componenteDemandante.validarpestania().valido;
          break;
        }
        case 2: {
          encontrarPaso.valor = this.componenteDemandado.demandados.length > 0;
          break;
        }
        case 3: {
          encontrarPaso.valor =
            this.componenteReclamoDirecto.formReclamoDirecto.valid;
          break;
        }
        case 4: {
          encontrarPaso.valor =
            this.componenteProteccion.formTipoProteccion.valid ||
            this.componenteProteccion.isSelectedFormValid();
          break;
        }
        case 5: {
          encontrarPaso.valor = this.componentePretension.formPretension.valid;
          break;
        }
        case 7: {
          encontrarPaso.valor = this.componentePruebas.subio;
          break;
        }
      }
    }

    this.paso = paso;
  }

  guardarSinEnviarTramite(data: {
    tramite: TramiteSicProteccionConsumidorDto;
    event?: Event;
    archivo?: ArchivosFormDTO | null | undefined;
  }) {
    const tramite = data.tramite;
    const archivo = data.archivo;
    tramite.id = this.tramiteSIC?.id;
    tramite.enviar = false;

    this.enviar(tramite, false, archivo);
  }

  enviarTramite(data: {
    tramite: TramiteSicProteccionConsumidorDto;
    enviarCorreoDemandado: boolean;
    event: Event;
  }) {
    const tramite = data.tramite;
    tramite.id = this.tramiteSIC?.id;
    tramite.enviar = true;

    const validarPasos = this.estadoPasos.every(paso => paso.valor);
    if (validarPasos) {
      this.enviar(tramite, data.enviarCorreoDemandado);
    } else {
      const pasosConErrores = this.estadoPasos.filter(paso => !paso.valor);

      const mensaje = pasosConErrores.map(paso => `• ${paso.paso} `).join('\n');
      this.alertaModalService.advertencia(
        this.alertaText['sic-procon-alertas']['complete-pasos'],
        this.alertaText['sic-procon-alertas']['pasos-incompletos'] + mensaje
      );
    }
  }

  async enviar(
    tramite: TramiteSicProteccionConsumidorDto,
    enviarCorreoDemandado: boolean,
    archivo: ArchivosFormDTO | null | undefined = undefined
  ): Promise<{ success: boolean; message?: string }> {
    tramite['tipoTramiteNombreCorto'] = this.nombreCortoLimpio;
    if (this.tramiteSIC?.notificacionesDemandante != undefined) {
      // Filtrar elementos vacíos
      tramite.notificacionesDemandante =
        this.tramiteSIC?.notificacionesDemandante;
      tramite.notificacionesDemandante =
        tramite.notificacionesDemandante.filter(item => item !== '');

      if (tramite.notificacionesDemandante.length > 0) {
        // Validar que 'demandante' existe y tiene la misma longitud que 'notificacionesDemandante'
        if (
          this.tramiteSIC?.demandante &&
          this.tramiteSIC.demandante.length ===
          tramite.notificacionesDemandante.length
        ) {
          // Mapear los elementos y agregar el id del demandante al inicio
          tramite.notificacionesDemandante =
            tramite.notificacionesDemandante.map((item, index) => {
              const demandante = this.tramiteSIC?.demandante![index];
              if (demandante?.id) {
                const partes = item.split(';');
                if (partes.length === 2) {
                  // Agregar el id del demandante al inicio
                  return `${demandante.id};${partes[0]};${partes[1]}`;
                }
              }
              // Devolver el elemento sin cambios si no cumple las condiciones
              return item;
            });
        } else {
          console.error(
            "Los arrays 'demandante' y 'notificacionesDemandante' no coinciden en tamaño."
          );
        }
      }
    }
    if (this.tramiteSIC?.notificacionesDemandado != undefined) {
      // Filtrar elementos vacíos
      tramite.notificacionesDemandado =
        this.tramiteSIC?.notificacionesDemandado;
      tramite.notificacionesDemandado = tramite.notificacionesDemandado.filter(
        item => item !== ''
      );

      if (tramite.notificacionesDemandado.length > 0) {
        // Validar que 'demandante' existe y tiene la misma longitud que 'notificacionesDemandado'
        if (
          this.tramiteSIC?.demandado &&
          this.tramiteSIC.demandado.length ===
          tramite.notificacionesDemandado.length
        ) {
          // Mapear los elementos y agregar el id del demandante al inicio
          tramite.notificacionesDemandado = tramite.notificacionesDemandado.map(
            (item, index) => {
              const demandado = this.tramiteSIC?.demandado![index];
              if (demandado?.id) {
                const partes = item.split(';');
                if (partes.length === 2) {
                  // Agregar el id del demandado al inicio
                  return `${demandado.id};${partes[0]};${partes[1]}`;
                }
              }
              // Devolver el elemento sin cambios si no cumple las condiciones
              return item;
            }
          );
        } else {
          console.error(
            "Los arrays 'demandado' y 'notificacionesDemandado' no coinciden en tamaño."
          );
        }
      }
    }

    if (tramite.demandante) {
      tramite.demandante.forEach(demandante => {
        if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
          demandante.datosRepresentanteLegal = null;
        }
      });
    }

    try {
      tramite.idioma = this.idiomaActual;
      const response = await firstValueFrom(
        this.proteccionConsumidorService.crear(tramite, enviarCorreoDemandado, archivo)
      );
      this.tramiteSIC = response;
      if (response?.id) {
        if (tramite.enviar) {
          await this.alertaModalService
            .exito(
              this.alertaText['sic-procon-alertas']['enviado'],
              this.alertaText['sic-procon-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad)
            )
            .then(() => {
              this.router.navigate(['/expediente']);
            });
        } else {
          await this.alertaModalService.exito(
            this.alertaText['solicitud-pendiente-finalizar'],
            this.alertaText['sic-procon-alertas']['tramite-enviado-mensaje'].replace('{{proceso}}', this.proceso)
              .replace('{{entidad}}', this.entidad)
          );
        }
        return { success: true };
      } else {
        // this.alertaModalService.error(
        //   'Error',
        //   'El envio de la solicitud no se realizó satisfactoriamente.'
        // );
        return { success: false };
      }
    } catch (error) {
      // await this.alertaModalService.error(
      //   'Error inesperado',
      //   'Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.'
      // );
      return { success: false };
    }

    try {
      const response = await firstValueFrom(
        this.tramiteService.envioAEntidad(this.idTramite, this.nombreCortoLimpio)
      );
    } catch (error) {
      console.error('Error al enviar a entidad:', error);
    }

    // this.proteccionConsumidorService
    //   .crear(tramite)
    //   .subscribe((data: TramiteSicProteccionConsumidorDto) => {
    //     this.tramiteSIC = data;
    //
    //     if (data?.id) {
    //       if (tramite.enviar) {
    //         this.alertaModalService.exito(
    //           this.alertaText['sic-procon-alertas']['enviado'],
    //           'El envio la solicitud no implica la aceptación automática por parte de la SIC y dicha aprobación está sujeta a revisión por la entidad.'
    //         );
    //
    //         this.router.navigate(['/']);
    //       } else {
    //         this.alertaModalService.exito(this.alertaText['proceso-guardado-exitosamente']);
    //       }
    //     } else {
    //       this.alertaModalService.error(
    //         'Error',
    //         'El envio de la solicitud no se realizó satisfactoriamente.'
    //       );
    //     }
    //   });
  }

  getPretenciones(pretenciones: TipoPretensionDto[]) {
    if (pretenciones) {
      this.pretenciones = pretenciones;
    }
  }

  //Funciones para el manejo de pasos en la linea de avance (funciónes externa de govco.js)
  continuarLineaAvance(event: Event): void {
    const bodyActive = (event.target as HTMLElement).closest(
      '.body-linea-avance-govco'
    ) as HTMLElement;
    const idParent = bodyActive.getAttribute('data-la-parent');
    const elementParent = document.querySelector(idParent!) as HTMLElement;
    const headers = elementParent.querySelectorAll(
      '.header-linea-avance-govco'
    ) as NodeListOf<HTMLElement>;
    const bodys = elementParent.querySelectorAll('.body-linea-avance-govco');

    const indexActive = this.getActiveItemAdvanceLine(headers);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).nextItemAdvanceLineHorizontal(event);

    headers[indexActive].classList.remove('active-linea-avance-govco');
    headers[indexActive].classList.add('checked-linea-avance-govco');
    headers[indexActive + 1].classList.add('active-linea-avance-govco');
    headers[indexActive + 1].classList.remove('checked-linea-avance-govco');
    bodys[indexActive].classList.remove('active-linea-avance-govco');
    bodys[indexActive + 1].classList.add('active-linea-avance-govco');
  }

  getActiveItemAdvanceLine(headers: NodeListOf<HTMLElement>): number {
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].classList.contains('active-linea-avance-govco')) {
        return i;
      }
    }
    return 0;
  }

  ngOnDestroy() {
    //window.removeEventListener('beforeunload', this.unloadNotification);
  }

  getFormDemandante(form: {
    formTipoPersonaDemandante: FormGroup;
    formDemandante: FormGroup;
  }) {
    this.formTipoDemandante = form.formTipoPersonaDemandante;
    this.formDemandante = form.formDemandante;
  }

  agregarDemandante() {
    const representanteLegal: PersonaDto = {
      idTipoPersona:
        this.formTipoDemandante.value['tipoPersona'] === '2' ? undefined : 1,
      primerNombre: this.formDemandante.value['representativeFirstName'],
      segundoNombre: this.formDemandante.value['representativeSecondName'],
      primerApellido: this.formDemandante.value['representativFirstLastName'],
      segundoApellido:
        this.formDemandante.value['representativeSecondLastName'],
    };
    const demandante: PersonaDto = {
      idTipoPersona: Number(this.formTipoDemandante.get('tipoPersona')?.value),
      idTipoIdentificacion: Number(
        this.formDemandante.get('typeOfDocument')?.value
      ),
      identificacion: this.formDemandante.get('numberOfDocument')?.value,
      razonSocial: this.formDemandante.get('razonSocial')?.value,
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandante.get('address')?.value,
        },
      ],
      telefonoPrincipal: this.formDemandante.get('phone')?.value,
      municipio: { id: Number(this.formDemandante.get('municipality')?.value) },
      correoElectronico: this.formDemandante.get('email')?.value,
      datosRepresentanteLegal:
        this.formTipoDemandante.get('tipoPersona')?.value == 1
          ? null
          : representanteLegal,
      primerNombre: this.formDemandante.get('firstName')?.value,
      segundoNombre: this.formDemandante.get('secondName')?.value,
      primerApellido: this.formDemandante.get('firstLastName')?.value,
      segundoApellido: this.formDemandante.get('secondLastName')?.value,
      departamentoExtranjero: this.formDemandante.get(
        'otroDepartamentoDemandante'
      )?.value,
      ciudadExtranjero: this.formDemandante.get('otroMunicipioDemandante')
        ?.value,
    };
    let demandantes: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandantes')!
    );
    const existe = demandantes
      ? demandantes.some(
        item =>
          item.idTipoIdentificacion === demandante.idTipoIdentificacion &&
          item.identificacion === demandante.identificacion
      )
      : false;
    const isEmptyDemandado: boolean = this.searchInDemandados(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );
    const isEmptyApoderado: boolean = this.searchInApoderado(
      demandante.idTipoIdentificacion!,
      +demandante.identificacion!
    );
    if (isEmptyDemandado && isEmptyApoderado) {
      if (existe == false) {
        this.tramiteSIC?.demandante?.push(demandante);
      } else {
        demandantes.forEach(elemento => {
          this.tramiteSIC?.demandante?.push(elemento);
        });
      }
    }
  }

  getFormApoderado(form: { formApoderado: FormGroup }) {
    this.formApoderado = form.formApoderado;
  }

  agregarApoderado() {
    let apoderado: PersonaDto = {};
    apoderado = {
      idTipoPersona: 1,
      id: this.formApoderado.get('attorneyId')?.value,
      primerNombre: this.formApoderado.get('attorneyFirstName')?.value,
      segundoNombre: this.formApoderado.get('attorneySecondName')?.value,
      primerApellido: this.formApoderado.get('attorneyFirstLastName')?.value,
      segundoApellido: this.formApoderado.get('attorneySecondLastName')
        ?.value,
      identificacion: this.formApoderado.get('attorneyNumberOfDocument')
        ?.value,
      tarjetaProfesional: this.formApoderado.get('attorneyProfessionalCard')
        ?.value,
      direccionPersona: [
        {
          direccionNotificacion:
            this.formApoderado.get('attorneyAddress')?.value,
        },
      ],
      correoElectronico: this.formApoderado.get('attorneyEmail')?.value,
      esApoderado:
        true,
    };
    let apoderadoStorage: PersonaDto = JSON.parse(
      sessionStorage.getItem('apoderado')!
    );
    const existe = apoderadoStorage
      ? [apoderadoStorage].some(
        item =>
          item.idTipoIdentificacion ===
          apoderadoStorage.idTipoIdentificacion &&
          item.identificacion === apoderadoStorage.identificacion
      )
      : false;

    const isEmptyDemandado: boolean = this.searchInDemandados(
      +this.formApoderado.get('typeOfDocument')?.value,
      +apoderado.identificacion!
    );
    const isEmptyDemandante: boolean = this.searchInDemandantes(
      +this.formApoderado.get('typeOfDocument')?.value,
      +apoderado.identificacion!
    );

    if (isEmptyDemandado && isEmptyDemandante) {
      if (existe == false) {
        if (apoderado.identificacion) {
          apoderado.idTipoIdentificacion =
            this.formApoderado.get('typeOfDocument')?.value;
          this.tramiteSIC!.apoderado = apoderado;
        }
      } else {
        this.tramiteSIC!.apoderado = apoderadoStorage;
      }
    }
  }

  getFormDemandado(form: {
    formTipoPersonaDemandado: FormGroup;
    formDemandado: FormGroup;
  }) {
    this.formTipoDemandado = form.formTipoPersonaDemandado;
    this.formDemandado = form.formDemandado;
  }

  agregarDemandado() {
    const { tipoPersona } = this.formTipoDemandado.value;

    const isPersonaNatural = tipoPersona === '1';

    const demandado: PersonaDto = {
      idTipoPersona: Number(tipoPersona),
      idTipoIdentificacion: this.formDemandado.get('typeOfDocument')?.value,
      identificacion: this.formDemandado.get('numberOfDocument')?.value,
      razonSocial: !isPersonaNatural
        ? this.formDemandado.get('razonSocial')?.value
        : undefined,
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandado.get('address')?.value,
        },
      ],
      telefonoPrincipal: this.formDemandado.get('phone')?.value,
      municipio: {
        id: this.formDemandado.get('municipality')?.value,
      },
      departamentoExtranjero: this.formDemandado.get(
        'otroDepartamentoDemandado'
      )?.value,
      ciudadExtranjero: this.formDemandado.get('otroMunicipioDemandado')?.value,
      correoElectronico: this.formDemandado.get('email')?.value,
      primerNombre: isPersonaNatural
        ? this.formDemandado.get('firstName')?.value
        : undefined,
      segundoNombre: isPersonaNatural
        ? this.formDemandado.get('secondName')?.value
        : undefined,
      primerApellido: isPersonaNatural
        ? this.formDemandado.get('firstLastName')?.value
        : undefined,
      segundoApellido: isPersonaNatural
        ? this.formDemandado.get('secondLastName')?.value
        : undefined,
    };

    const isEmptyDemandante: boolean = this.searchInDemandantes(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );
    const isEmptyApoderado: boolean = this.searchInApoderado(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );
    let demandados: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandados')!
    );

    const existe = demandados
      ? demandados.some(
        item =>
          item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
          item.identificacion === demandado.identificacion
      )
      : false;
    if (isEmptyDemandante && isEmptyApoderado) {
      if (existe == false) {
        this.tramiteSIC?.demandado?.push(demandado);
      } else {
        demandados.forEach(elemento => {
          this.tramiteSIC?.demandado?.push(elemento);
        });
      }
    }
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number
  ): boolean {
    let isEmpty = true;
    let demandantes: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandantes')!
    );
    if (demandantes) {
      demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          isEmpty = false;
        }
      });
    } else if (this.tramiteSIC) {
      if (this.tramiteSIC.demandante) {
        this.tramiteSIC.demandante.forEach(elemento => {
          if (
            elemento.idTipoIdentificacion === idTipoDocumento &&
            +elemento.identificacion! === identificacion
          ) {
            isEmpty = false;
          }
        });
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    let demandados: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandados')!
    );

    if (demandados) {
      demandados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion === idTipoDocumento &&
          +elemento.identificacion! === identificacion
        ) {
          isEmpty = false;
        }
      });
    } else if (this.tramiteSIC) {
      if (this.tramiteSIC.demandado) {
        this.tramiteSIC.demandado.forEach(elemento => {
          if (
            elemento.idTipoIdentificacion === idTipoDocumento &&
            +elemento.identificacion! === identificacion
          ) {
            isEmpty = false;
          }
        });
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    let apoderadoStorage: PersonaDto = JSON.parse(
      sessionStorage.getItem('apoderado')!
    );
    if (this.tramiteSIC?.apoderado) {
      if (
        this.tramiteSIC?.apoderado.idTipoIdentificacion === idTipoDocumento &&
        +this.tramiteSIC?.apoderado.identificacion! === identificacion
      ) {
        isEmpty = false;
      }
    } else if (apoderadoStorage) {
      if (
        apoderadoStorage.idTipoIdentificacion === idTipoDocumento &&
        +apoderadoStorage.identificacion! === identificacion
      ) {
        isEmpty = false;
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  getFormReclamo(formObj: {
    formReclamo: FormGroup;
  }) {
    this.formReclamo = formObj.formReclamo;
  }

  agregarReclamo() {
    const item = this.listaTipoReclamacion.find(
      item => item.Id === this.formReclamo.value['tipoReclamacion']
    );

    const listaValor: ListaValorRequestDto = {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    };

    const tramite: TramiteSicProteccionConsumidorDto = {
      tipoReclamacion: listaValor,
      fechaReclamo: this.formReclamo.value['fechaReclamo'],
      recibioRespuesta:
        this.formReclamo.value['recibioRespuesta'] === 'S',
      respuestaReclamoDirecto:
        this.formReclamo.value['respuestaReclamoDirecto'],
      fechaRespuesta: this.formReclamo.value['fechaRespuesta'],
      expidioConstancia: this.formReclamo.value['expidioConstancia']
    };
    this.tramiteSIC!.tipoReclamacion = tramite.tipoReclamacion;
    this.tramiteSIC!.fechaReclamo = tramite.fechaReclamo;
    this.tramiteSIC!.recibioRespuesta = tramite.recibioRespuesta;
    this.tramiteSIC!.respuestaReclamoDirecto = tramite.respuestaReclamoDirecto;
    this.tramiteSIC!.fechaRespuesta = tramite.fechaRespuesta;
    this.tramiteSIC!.expidioConstancia = tramite.expidioConstancia;
  }


  listaValor() {
    this.listaValorService.lista('SIC_TIPO_RECLAMACION').subscribe(data => {
      const response = data as ListaValorResponseDto[];
      this.listaTipoReclamacion = response;
    });
  }
}
